<template>
  <div v-show="dialpadVisible" :class="$style.container">
    <h1>Dialpad</h1>

    <back-to-call
      @click="hideDialpad"
      :name="contactName || contactNumber"
      :photoUrl="contactPhotoUrl" />

    <output :class="$style.dialed">{{enteredKeys}}</output>

    <Dialpad @input="handleInput" />
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import EventBus from '@/lib/event-bus'
  import Dialpad from '@/components/shared/Dialpad'
  import BackToCall from '../shared/back-to-call/back-to-call'

  const { mapState, mapGetters, mapActions } = createNamespacedHelpers('conference')

  export default {
    components: {
      Dialpad,
      BackToCall
    },
    data () {
      return {
        enteredKeys: ''
      }
    },
    computed: {
      ...mapState([
        'dialpadVisible'
      ]),
      ...mapGetters([
        'contactName',
        'contactNumber',
        'contactPhotoUrl'
      ])
    },
    methods: {
      ...mapActions([
        'hideDialpad'
      ]),
      handleInput ({key, keys}) {
        this.enteredKeys = keys
        EventBus.$emit('DIALPAD_KEY', key)
      }
    }
  }
</script>

<style module lang="less" src="./dialpad.less"></style>



// WEBPACK FOOTER //
// dialpad.vue?522071c8